/**
 * Custom events for GTM
 */

(function (window, document, $, undefined) {
	'use strict';

	// override gtmHelper object, instead append to existing
	window.gtmHelper = window.gtmHelper || {};
	window.gtmHelperAppend = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			gtmHelper.initVars();
			gtmHelper.bind();
			gtmHelper.pageInit();
		},

		/**
		 * Setting and initializing all variables.
		 *
		 * @since 1.0.0
		 */
		initVars: function () {
		},

		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {
			// Bind to document downloads
			$( 'body' ).on( 'click', '.document-download', gtmHelper.trustDocumentDownloadEvent );
			// Bind to insights card click
			$( 'body' ).on( 'click', '.insights-article-card', gtmHelper.trustInsightsClickEvent );
			// Bind to trust filter click
			$( 'body' ).on( 'change', '#region-select', gtmHelper.trustFilterRegionChangeEvent );
			$( 'body' ).on( 'click', '.filters__chip', gtmHelper.trustFilterChipClickEvent );
			// Bind to FAQ expand click
			$( 'body' ).on( 'click', '#FAQ_block .faq__item', gtmHelper.trustFAQclickEvent );
			// Bind to Product page - Fund Chart Interactions
			// $( 'body' ).on( 'click', '.fund-chart-name', gtmHelper.fundChartInteraction );
			//Bind to Audio events
			// $( 'body' ).on( 'click', '.mejs-button', gtmHelper.audioEvent );;
		},

		/**
		 *  ProductFilter- Event Tracking
		 *
		 * @since 1.0.0
		 */
		productFilterEvent: function ( name, value ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' : 'product-table-filter',
					'product-table-filter' : {
						'name'  : name,
						'value' : value
					}
				}
			);
		},

		/**
		 *  Actions we want to perform on every page.
		 *
		 * @since 1.0.0
		 */
		pageInit: function () {
			// Add document-download class to pdf links if they don't already have it
			$( "a[href$='.pdf'], a[href$='.PDF'], a[href*='/document/'], a[href*='/documents/docId']" ).not( '.document-download' ).addClass( 'document-download' );

			// Add data-extension to service document links
			$( "a[href*='/documents/docId']" ).attr( 'data-extension', 'pdf' );
		},

		/**
		 *  Track Fund Chart Interaction events
		 *
		 * @since 1.0.0
		 */
		fundChartInteraction: function ( chartName ) {
			if ( typeof chartName == 'string' ) {
				//get the 10k growth chart title
				chartName = $.trim( chartName );
			} else {
				//get the main title for morninigstar percentile - no need for other chart tables
				var chartTitle = $( this ).closest( '.mrg-perc' ).find( '.mrg-perc-title' ).text();
				//concate with tab-name chart tables
				chartName = $.trim( $.trim( chartTitle.replace( /[\t\n]+/g,' ' ) ) + ' ' + $.trim( $( this ).text() ) );
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	 : 'fund-chart-interaction',
					'fund-chart' : {
						'name'   : chartName,
					},
				}
			);
		},

		/**
		 *  Get Audio events(play/pause/end)
		 *
		 * @since 1.0.0
		 */
		audioEvent: function ( ) {
			var url   = $( this ).closest( '.mejs-audio' ).find( '.wp-audio-shortcode' ).attr( "src" );
			var title = $.trim( $( this ).closest( '.mejs-audio' ).closest( '.fl-module' ).prev().find( '.fl-rich-text' ).text() );
			$.each(
				$( this ).attr( 'class' ).split( /\s+/ ),
				function(index, item) {
					if (item === 'mejs-play') {
						//Play event
						gtmHelper.trackAudioEvent( 'play', title, url );
					}
					if ( item === 'mejs-pause' ) {
						//Pause event
						gtmHelper.trackAudioEvent( 'pause', title, url );
					}
				}
			);
		},

		/*
		 Track audio player events
		 event audio
		 audio.action One of; play, pause or ended.
		 audio.title The title of the audio being played. This should be a user-friendly name where possible.
		 audio.url The URL of the audio file being played.
		 */
		trackAudioEvent: function( action, title, url ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event': 'audio',
					'audio': {
						'action': action,
						'title': title,
						'url': url
					}
				}
			);
		},

		/**
		 *  Track document downloads
		 */

		trustDocumentDownloadEvent: function (e) {
			var url           = $( this ).attr( "href" );
			var fileExtension = $( this ).attr( "data-extension" ) || gtmHelper.getFileExtension( url ).toLowerCase();
			var name          = $( this ).attr( "data-name" ) || undefined;
			var type          = $( this ).attr( "data-doc_type" ) || undefined;

			// Create the dataLayerObject for a later push onto dataLayer
			var dataLayerObject = {
				'event': 'download_click',
				'title': name,
				'file_type': fileExtension,
				'file_location': url,
				'content_type': type
			};

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( dataLayerObject );
		},

		/**
		 *  Track trust filter use
		 */

		trustFilterRegionChangeEvent: function (e) {
			var selectedRegion = $(e.target).val();

			// Create the dataLayerObject for a later push onto dataLayer
			var dataLayerObject = {
				'event': 'filter_click',
				'filter_type': 'Region',
				'filter_name': selectedRegion,
			};

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( dataLayerObject );
		},
		
		trustFilterChipClickEvent: function (e) {
			var selectedChip = $(this).attr('value');

			// Create the dataLayerObject for a later push onto dataLayer
			var dataLayerObject = {
				'event': 'filter_click',
				'filter_type': 'Objective',
				'filter_name': selectedChip,
			};

			// Check to ensure GTM is loaded, this will ensure e.preventDefault() doesn't block the URL change in case of GTM instance missing.
			if (window['google_tag_manager']) {

				window.dataLayer = window.dataLayer || [];

				window.dataLayer.push( dataLayerObject );
			}
		},

		/**
		 * Insights click event
		 */
		trustInsightsClickEvent: function (e) {
			var position = $( this ).attr( "data-article_position");
			var format  = $( this ).attr( "data-content_type" ) || undefined;
			var publishDate  = $( this ).attr( "data-publish_date" ) || undefined;

			// Function to find an element, first as a child, then in the closest parent
			var findElement = function(target, selector) {
				var element = $(target).find(selector).first();
				if (element.length === 0) {
					element = $(target).closest('.insights-article-card').find(selector).first();
				}
				return element;
			};

			// Finding the title, byline, and read-time elements
			var titleElement = findElement(e.target, '.insights-article-card__title a');
			var bylineElement = findElement(e.target, '.insights-article-card__byline');
			var readTimeElement = findElement(e.target, '.insights-article-card__read-time');

			// Extracting text content
			var title = titleElement.length > 0 ? titleElement.text().trim() : undefined;
			var byline = bylineElement.length > 0 ? bylineElement.text().trim().replace(/\s+/g, ' ') : undefined;
			var readTime = readTimeElement.length > 0 ? readTimeElement.text().trim() : undefined;

			// Create the dataLayerObject for a later push onto dataLayer
			var dataLayerObject = {
				'event': 'content_card_click',
				'position': position,
				'title': title,
				'content_type': format,
				'author': byline,
				'published_date': publishDate,
				'reading_time': readTime
			};

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( dataLayerObject );
		},

		/**
		 * Trust FAQ Click Event
		 */

		trustFAQclickEvent: function (e) {
			var question = $(this).attr('data-section_title');
			var accordion_name = $(this).attr('data-accordion_name');
			var dataArray = window.dataLayer[0];
			if (dataArray.pageMeta){
				var title = dataArray.pageMeta.title;
			}

			// Create the dataLayerObject for a later push onto dataLayer
			var dataLayerObject = {
				'event': 'accordion_expand',
				'section_title': question,
				'page': title,
				'accordion_name': accordion_name
			};

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( dataLayerObject );
		},

		/**
		 *  Get the file extension of a document
		 *
		 * @since 1.0.0
		 */
		getFileExtension: function (filename) {
			filename = gtmHelper.removeQueryParam( filename );
			return filename.split( '.' ).pop();

		},

		/**
		 *  Get the file extension of a document
		 *
		 * @since 1.0.0
		 */
		removeQueryParam: function (url) {
			var urlParts = url.split( '?' );
			if (urlParts.length >= 2) {
				// Strip query param
				url = url.split( '?' )[0];
			}
			return url;
		},
	}

	window.gtmHelper = $.extend({}, window.gtmHelper, window.gtmHelperAppend);
	gtmHelper.init();

})( window, document, jQuery );

// Bind MediaElement player - Tracking audio event(end) for Analytics
// jQuery( document ).ready(
// 	function ($) {
// 		if ( $.fn.mediaelementplayer ) {
// 			$( "audio" ).mediaelementplayer(
// 				{
// 					success: function (mediaElement, domObject, player) {
// 						var title = $.trim( $( '.mejs-audio' ).closest( '.fl-module' ).prev().find( '.fl-rich-text' ).text() );
// 						var url   = mediaElement.src || undefined;
// 						mediaElement.addEventListener(
// 							'ended',
// 							function () {
// 								gtmHelper.trackAudioEvent( 'ended', title, url );
// 							}
// 						);
// 					}
// 				}
// 			);
// 		}
// 	}
// );
